import React from 'react'
import {isEmpty} from 'lodash'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import EditAgencyProducer from './EditAgencyProducer'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'
import AgencyProducerNotFound from './AgencyProducerNotFound'

import Resource from '../../stores/resource'
const AgProducerStore = Resource('agency-producers')

class EditAgencyProducerPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      agencyProducer: {},
      error: '',
      loading: true
    }
  }

  componentWillMount() {
    AgProducerStore.findBy({id: this.props.match.params.id}, ['agency'])
    .then((result) => this.setState({
      agencyProducer: result.data,
      loading: false
    }))
    .catch((error) => this.setState({
      agencyProducer: {},
      error: errors.unpack(error),
      loading: false
    }))
  }

  _closeErrorDialog = () => this.setState({error: ''})

  render() {
    const {
      agencyProducer,
      error,
      loading
    } = this.state

    if (loading) return <LinearLoader />
    if (isEmpty(agencyProducer)) return <AgencyProducerNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            Edit external project manager
          </PageTitle>
        </header>

        <EditAgencyProducer agencyProducer={agencyProducer} />
        <br/>
        <BackButton/>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }

}

export default EditAgencyProducerPage



// WEBPACK FOOTER //
// ./src/components/AgencyProducers/EditAgencyProducerPage.jsx